<template>
  <split-transload-and-deliver :back="{ name: 'IncidentProcessTransload' }"/>
</template>

<script>
import SplitTransloadAndDeliver from "@/components/3pl/IncidentAndRequest/Transload/SplitTransloadAndDeliver";
export default {
  components: { 
    SplitTransloadAndDeliver,
  },
};
</script>

<style>
</style>